/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrRegistrationInfosDto } from '../../models/dbr-registration-infos-dto';

export interface BalloonsControllerCheckIsRegistered$Params {
  code: string;
}

export function balloonsControllerCheckIsRegistered(http: HttpClient, rootUrl: string, params: BalloonsControllerCheckIsRegistered$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrRegistrationInfosDto>> {
  const rb = new RequestBuilder(rootUrl, balloonsControllerCheckIsRegistered.PATH, 'get');
  if (params) {
    rb.path('code', params.code, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DbrRegistrationInfosDto>;
    })
  );
}

balloonsControllerCheckIsRegistered.PATH = '/balloons/registered/{code}';
